var path = 'app/scripts/modules/dcos/pipeline/stages/resizeAsg/resizeAsgStepLabel.html';
var html = "<span class=\"task-label\">\n  Resize Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/pipeline/stages/resizeAsg/resizeAsgStepLabel.html
// module id = 1742
// module chunks = 0